import React from 'react';
import Button from '../components/Button';
// import PropTypes from 'prop-types';

export default function App() {
  return <Button size="lg">Hello</Button>;
}
